<div
  class="custom-notification"
  [ngClass]="{
    'info-notification': toastPackage.toastType === 'info',
    'warning-notification': toastPackage.toastType === 'warning',
    'error-notification': toastPackage.toastType === 'error',
  }"
  [@flyInOut]="state()">
  <!-- Notification Icon -->
  <div class="custom-notification-icon">
    @if (toastPackage.toastType === 'info') {
      <mat-icon class="notification-icon">notifications</mat-icon>
    } @else if (toastPackage.toastType === 'warning') {
      <mat-icon class="notification-icon">warning</mat-icon>
    } @else if (toastPackage.toastType === 'error') {
      <mat-icon class="notification-icon">error</mat-icon>
    }
  </div>

  <!-- Notification Message -->
  <div class="custom-notification-message">
    <b>{{ title() }}</b>
    <p class="mb-0" [innerHTML]="message()" style="white-space: pre-wrap"></p>
  </div>

  <!-- Notification Actions (OK button and close icon) -->
  <div class="custom-notification-actions">
    <!-- OK Button -->
    <button mat-button (click)="remove()">
      {{ toastPackage.toastType === 'error' ? 'I Understand' : 'OK' }}
    </button>
  </div>
</div>
